import { Box } from '@mui/material';
import React from 'react';
import { getMapDataSelected } from '../../reducer/mapDataSelectedSlice';
import { useSelector } from 'react-redux';
import MorbidityContent from './dengue/MorbidityContent';
import CompareContent from './dengue/CompareContent';
import PatientContent from './dengue/PatientContent';
import SpotmapContent from './dengue/SpotmapContent';
import ClusterContent from './dengue/ClusterContent';
import IndexContent from './dengue/IndexContent';

function DataShow() {
    const mapDataSelected = useSelector(getMapDataSelected);
    // const [type, setType] = useState();

    // useEffect(() => {
    //     setType(mapDataSelected.values_.datatype);
    // }, [mapDataSelected])

    const content = () => {
        // console.log(mapDataSelected);
        if (Object.keys(mapDataSelected).length !== 0) {
            // console.log(mapDataSelected.values_);
            // if (mapDataSelected.values_) {

            // }
            // console.log(mapDataSelected.values_);
            let selectedType = "";
            if (mapDataSelected.values_.features) {
                selectedType = mapDataSelected.values_.features[0].values_.datatype;
            } else {
                selectedType = mapDataSelected.values_.datatype
            }
            if (selectedType === "morbidity") {
                return (
                    <MorbidityContent data={mapDataSelected.values_.attributes} />
                )
            } else if (selectedType === "compare") {
                return (
                    <CompareContent data={mapDataSelected.values_.attributes} />
                )
            } else if (selectedType === "patient") {
                return (
                    <PatientContent data={mapDataSelected.values_.attributes} />
                )
            } else if (selectedType === "spotmap") {
                return (
                    <SpotmapContent data={mapDataSelected.values_} />
                )
            } else if (selectedType === 'cluster') {
                return (
                    <ClusterContent data={mapDataSelected.values_} />
                )
            } else if (selectedType === 'index') {
                return (
                    <IndexContent data={mapDataSelected.values_} />
                )
            }
        } else {
            return (<></>)
        }
    }

    return (
        <Box
            sx={{ width: 350 }}
            role="presentation"
        >
            {
                content()
            }
        </Box>
    )
}

export default DataShow
